import Head from 'next/head'
import styles from './Article.module.scss'
import {
  storyblokEditable,
  SbBlokData,
  ISbRichtext,
} from '@storyblok/react/rsc'
import clsx from 'clsx'
import Footer from '../Footer'
import Navbar from '../Navbar'
import Text from '@/components/storyblok/Text'
import Section from '@/components/storyblok/Section'

export interface PageBlok extends SbBlokData {
  pageSeo: {
    description?: string
    og_description?: string
    og_image?: string
    og_title?: string
    plugin: string
    title: string
    twitter_description?: string
    twitter_image?: string
    twitter_title?: string
    _uid: string
  }
  pageTitle: string
  pageContent?: ISbRichtext[]
}

interface PageProps {
  blok: PageBlok
}

const Article = ({ blok }: PageProps) => {
  return (
    <>
      <Head>
        <title>{blok.pageSeo?.title || blok.pageTitle}</title>
        {blok.pageSeo?.description && (
          <meta name="description" content={blok.pageSeo.description} />
        )}
        {/* Open Graph tags */}
        {blok.pageSeo?.og_title && (
          <meta property="og:title" content={blok.pageSeo.og_title} />
        )}
        {blok.pageSeo?.og_description && (
          <meta property="og:description" content={blok.pageSeo.og_description} />
        )}
        {blok.pageSeo?.og_image && (
          <meta property="og:image" content={blok.pageSeo.og_image} />
        )}
        {/* Twitter Card tags */}
        {blok.pageSeo?.twitter_title && (
          <meta name="twitter:title" content={blok.pageSeo.twitter_title} />
        )}
        {blok.pageSeo?.twitter_description && (
          <meta name="twitter:description" content={blok.pageSeo.twitter_description} />
        )}
        {blok.pageSeo?.twitter_image && (
          <meta name="twitter:image" content={blok.pageSeo.twitter_image} />
        )}
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <main className={styles.article} {...storyblokEditable(blok)}>
        <Navbar background="background__transparent" />
        <Section
          blok={{
            _uid: 'section-article-hero',
            content: [],
            backgroundColor: 'background__linear--top',
            internalName: 'Article Hero',
            vAlign: 'center',
            component: 'section',
            backgroundMedia: [],
            sectionHeader: '',
            footer: [],
            borderBottom: false,
            borderTop: false,
            showWaveParticles: false
          }}
        >
          <div
            className={clsx(
              styles.article__hero,
              styles.article__hero__container
            )}
          >
            <div className={styles.article__hero__title}>
              <h1>{blok.pageTitle}</h1>
            </div>
          </div>
        </Section>
        <section className={styles.article__content}>
          {(Array.isArray(blok.pageContent) ? blok.pageContent : blok.pageContent ? [blok.pageContent] : []).map(
            (content, idx) => (
              <Text
                key={idx}
                wrapperClass={styles.article__content}
                blok={{ text: content }}
              />
            )
          )}
        </section>
        <Footer />
      </main>
    </>
  )
}

export default Article
